import { Button, ButtonProps, chakra } from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { useRouteMatch } from '@/hooks/useRouteMatch';

export type NavigationButtonProps = {
  href: string;
  matchHref?: string | string[];
  isExact?: boolean;
  isActive?: boolean;
  newView?: boolean;
} & ButtonProps;

export const NavigationButton: React.FC<NavigationButtonProps> = ({
  href,
  matchHref,
  children,
  isExact,
  isActive,
  newView = false,
  ...buttonProps
}) => {
  const isRouteMatch = useRouteMatch(matchHref ?? href, { isExact });

  const isConsideredActive = isActive !== undefined ? isActive : isRouteMatch;

  return (
    <Button
      as={NextLink}
      href={href}
      whiteSpace="normal"
      variant="ghost"
      justifyContent="left"
      colorScheme="secondary"
      isActive={isConsideredActive}
      size="md"
      color={isConsideredActive ? 'textPrimary.500' : 'textSecondary.500'}
      borderLeft={newView && isConsideredActive ? "5px solid" : "5px solid"}
      borderColor={newView && isConsideredActive ? "primary.500" : "transparent"}
      borderRadius={newView && isConsideredActive ? "0 6px 6px 0" : "6px 6px 6px 6px"}
      _hover={{
        bg: "secondary.500"
      }}
      {...buttonProps}
      w="full"
    >
      <chakra.span noOfLines={1} wordBreak="break-all" style={{borderRadius: "6px"}}>
        {children}
      </chakra.span>
    </Button>
  );
};
